import { lazyNamed } from 'src/utils/lazyNamed';

const Authentication = {
  Forms: {
    Login: lazyNamed(() => import('./forms/Login'), 'Login'),
    Registration: lazyNamed(() => import('./forms/Registration'), 'Registration'),
    Verification: lazyNamed(() => import('./forms/Verification'), 'Verification'),
    RestorePassword: lazyNamed(() => import('./forms/RestorePassword'), 'RestorePassword'),
    ChangePassword: lazyNamed(() => import('./forms/ChangePassword'), 'ChangePassword'),
    ActivateUser: lazyNamed(() => import('./forms/ActivateUser'), 'ActivateUser'),
  },
  Components: {
    Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
    Redirector: lazyNamed(() => import('./components/Redirector'), 'Redirector'),
    SSO: lazyNamed(() => import('./components/SSO'), 'SSO'),
    Autologin: lazyNamed(() => import('./components/Autologin'), 'Autologin'),
  },
};

export default Authentication;
